import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { format } from 'date-fns';
import Swal from 'sweetalert2';
import { API_BASE_URL } from '../../../../../config';
const UPAS = () => {
  const [currency, setCurrency] = useState('USD($)');
  const [bankList, setBankList] = useState([]);
  const [formData, setFormData] = useState({
    lc_applicant: '',
    issue_bank: '',
    amount: '',
    lc_currency: 'USD($)',
    lc_value: '',
    lc_maturity: '',
    maturity: '',
    product_name: '',
    beneficiary: '',
    tenor_required: '12',
    document: null,
  });
  const [errors, setErrors] = useState({});
  const [isFormVisible, setIsFormVisible] = useState(true);
  const [tenorRequired, setTenorRequird] = useState('12');
  const navigate = useNavigate();

  const handleCurrencyChange = currency => {
    setCurrency(currency);
    setFormData({ ...formData, lc_currency: currency });
  };
  const handleTenorRequirdChange = tenor => {
    setTenorRequird(tenor);
    setFormData({ ...formData, tenor_required: tenor });
  };

  const handleInputChange = e => {
    const { id, value } = e.target;
    setFormData({
      ...formData,
      [id]: value,
    });
  };

  const handleFileChange = e => {
    setFormData({
      ...formData,
      document: e.target.files[0], // Store the selected file in formData
    });
  };

  const handleCloseApplyLoan = () => {
    setIsFormVisible(false);
    navigate('/NewLoanApplication');
  };

  // get all issue bank api
  useEffect(() => {
    const fetchBankList = async () => {
      try {
        const response = await axios.get(
          `${API_BASE_URL}/account/bank-list/`,
          // 'https://finwise-backend.vercel.app/account/bank-list/',
          // 'https://finwiseback.finwise.com.bd/account/bank-list/',
          // 'http://127.0.0.1:8000/account/bank-list/',
          {
            headers: {
              Cookie:
                'csrftoken=YmXTCIwY0VzFyPEcOP15TL1stJiuNrZF; sessionid=l2509fh2uv9ulyzd6412afq0ufd2elpr',
            },
            withCredentials: true,
          }
        );

        // Assuming the response has a list of banks
        setBankList(response.data);
        // console.log(response);
      } catch (error) {
        console.error('Error fetching the bank list:', error);
      }
    };

    fetchBankList();
  }, []);

  // fields validation
  const validateForm = () => {
    let validationErrors = {};
    if (!formData.lc_applicant)
      validationErrors.lc_applicant = 'LC Applicant is required';
    if (!formData.issue_bank)
      validationErrors.issue_bank = 'Issue Bank is required';
    if (!formData.amount) validationErrors.amount = 'Amount is required';
    if (!formData.lc_value) validationErrors.lc_value = 'LC Value is required';
    if (!formData.lc_maturity)
      validationErrors.lc_maturity = 'LC Maturity date is required';
    if (!formData.product_name)
      validationErrors.product_name = 'Product Name is required';
    if (!formData.beneficiary)
      validationErrors.beneficiary = 'Beneficiary is required';
    if (!formData.tenor_required)
      validationErrors.tenor_required = 'Tenor Required is required';
    setErrors(validationErrors);
    return Object.keys(validationErrors).length === 0;
  };

  const handleSubmit = async e => {
    e.preventDefault();
    //  if (!validateForm()) return;

    // Prepare form data for submission
    const submissionData = new FormData();
    submissionData.append('lc_applicant', formData.lc_applicant);
    submissionData.append('issue_bank', formData.issue_bank);
    submissionData.append('beneficiary_bank', formData.beneficiary);
    submissionData.append('lc_currency', formData.lc_currency);
    submissionData.append('lc_value', formData.lc_value );
    submissionData.append('tenor_required', formData.tenor_required);
    // submissionData.append('product_name', formData.product_name);
    // submissionData.append(
    //   'lc_maturity',
    //   format(new Date(formData.lc_maturity), 'yyyy-MM-dd')
    // );
    // Check if product_name is provided and append it if available
    if (formData.product_name) {
      submissionData.append('product_name', formData.product_name);
    }

    // Check if lc_maturity is provided and append it if available
    if (formData.lc_maturity) {
      submissionData.append(
        'lc_maturity',
        format(new Date(formData.lc_maturity), 'yyyy-MM-dd')
      );
    }
    if (formData.document) {
      submissionData.append(
        'document',
       null
      );
    }
    // if (formData.document) {
    //   submissionData.append(
    //     'document',
    //     formData.document,
    //     formData.document.name
    //   );
    // }

    try {
      const response = await axios.post(
        `${API_BASE_URL}/account/apply-loan/`,
        submissionData,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
            Cookie:
              'csrftoken=YmXTCIwY0VzFyPEcOP15TL1stJiuNrZF; sessionid=l2509fh2uv9ulyzd6412afq0ufd2elpr',
          },
          withCredentials: true,
        }
      );

      Swal.fire({
        title: 'Success!',
        text: 'UPAS application success.',
        customClass: {
          popup: 'w-72 h-auto p-3',
          title: 'text-lg',
          content: 'text-xs',
          confirmButton: 'bg-headerBtn text-white px-4 py-1 text-sm rounded-md',
        },
      });
      navigate('/dashboard');
    } catch (error) {
      if (error.response) {
        Swal.fire({
          title: 'Error!',
          text: error.response.data?.[0] || 'Please provide valid information.',
          customClass: {
            popup: 'w-72 h-auto p-3',
            title: 'text-lg',
            content: 'text-xs',
            confirmButton:
              'bg-headerBtn text-white px-4 py-1 text-sm rounded-md',
          },
        });
        console.error('Server response error:', error.response.data);
      } else {
        console.error('Error submitting loan application:', error);
      }
    }
  };

  return (
    <>
      {isFormVisible && (
        <div className="md:px-10 px-2 md:py-10 py-6 ">
          {/* title header */}
          <div className="bg-headerBtn md:w-full p-2  md:pl-8 pl-4 text-left rounded-t-lg ">
            <div className="flex justify-between">
              <div>
                <h2 className="md:text-2xl text-lg text-white font-bold md:mb-2">
                  Apply for Your UPAS Today
                </h2>
                <p className="md:mb-2 text-xs md:text-sm text-white">
                  Quick, Easy, and Secure – Get the Funds You Need Fast
                </p>
              </div>

              {/* Close button */}
              {/* <button
                onClick={handleCloseApplyLoan}
                className="md:mr-4 mr-3 -mt-6 text-white text-2xl font-bold hover:text-btnHover"
              >
                &times;
              </button> */}
            </div>
          </div>

          {/* form fields */}
          <div className="bg-AboutUsBg md:text-sm text-xs flex flex-col items-center md:py-10 py-4 px-4 md:px-0 h-screen">
            <form onSubmit={handleSubmit} className="w-full max-w-4xl">
              {/* All form fields start from here */}
              <div className="md:space-y-2 space-y-2">
                {/* LC Applicant */}
                <div className="flex flex-col md:flex-row md:items-center md:space-x-0 md:gap-24 gap-1">
                  <div>
                    <label
                      htmlFor="lcApplicant"
                      className="block font-medium text-gray-700"
                    >
                      <div className="flex md:flex-col gap-1">
                        <span>
                          1. LC Applicant<span className="text-red-600">*</span>
                        </span>
                      </div>
                    </label>
                  </div>

                  <div className="flex md:gap-2">
                    <div>
                      <span className="text-3xl hidden md:block ml-0.5">:</span>
                    </div>

                    <input
                      type="text"
                      id="lc_applicant"
                      value={formData.lc_applicant}
                      onChange={handleInputChange}
                      placeholder="Enter LC Applicant"
                      className="md:w-96 w-48 p-2 border border-gray-300 rounded-md"
                      required
                    />
                  </div>
                </div>
                {/* Issue Bank */}
                <div className="flex flex-col md:flex-row md:items-center md:space-x-0 md:gap-24 gap-1 ">
                  <div>
                    <label
                      htmlFor="issueBank"
                      className="block font-medium text-gray-700"
                    >
                      2. Issue Bank<span className="text-red-600">*</span>
                    </label>
                  </div>

                  <div className="flex md:gap-2">
                    <div>
                      <span className="text-3xl hidden md:block ml-3">:</span>
                    </div>

                    <div className="">
                      <select
                        id="issue_bank"
                        value={formData.issue_bank}
                        onChange={handleInputChange}
                        className="md:w-96 w-48 p-2 border border-gray-300 rounded-md shadow-sm focus:ring focus:ring-opacity-50"
                        required
                      >
                        <option value="">Select Bank</option>
                        {bankList.map((bank, index) => (
                          <option key={index} value={bank[0.0]}>
                            {bank[0.0]}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>
                </div>
                {/*LC value */}
                <div className="flex flex-col md:flex-row md:items-center md:space-x-0 md:gap-24 gap-1">
                  <div>
                    <label
                      htmlFor="lcValue"
                      className="block font-medium text-gray-700"
                    >
                      3. LC Value<span className="text-red-600">*</span>
                    </label>
                  </div>

                  <div className="flex gap-2">
                    <div>
                      <span className="hidden md:block text-3xl ml-6">:</span>
                    </div>

                    <div className="flex gap-3  ">
                      <input
                        type="text"
                        id="lc_value"
                        value={formData.lc_value}
                        onChange={handleInputChange}
                        placeholder="Enter LC Value"
                        className="md:w-96 w-48 p-2 border border-gray-300 rounded-md md:ml-0 -ml-2"
                        required
                        onInput={e => {
                          // Remove non-numeric characters and format with commas every three digits
                          let value = e.target.value
                            .replace(/[^0-9]/g, '') // Allows only numbers
                            .replace(/\B(?=(\d{3})+(?!\d))/g, ','); // Adds a comma every three digits from the right

                          e.target.value = value;
                        }}
                        onBlur={e => {
                          // Append .00 on blur if not already present
                          if (!e.target.value.includes('.')) {
                            e.target.value += '.00';
                          }
                        }}
                      />
                      {/* currency tab */}
                      <div className="flex space-x-0 rounded-sm">
                        {['USD($)', 'EURO(€)'].map(curr => (
                          <button
                            key={curr}
                            type="button"
                            onClick={() => handleCurrencyChange(curr)}
                            className={`lg:py-1 py-0 lg:px-2 px-1.5 border border-black lg:text-sm text-[8px] lg:font-normal font-bold ${
                              currency === curr
                                ? 'bg-black text-white'
                                : 'bg-AboutBG'
                            }`}
                          >
                            {curr}
                          </button>
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
                {/* Beneficiary Bank*/}
                <div className="flex flex-col md:flex-row md:items-center md:space-x-0 md:gap-24 gap-1 ">
                  <div>
                    <label
                      htmlFor="beneficiary_bank"
                      className="block font-medium text-gray-700"
                    >
                      4. Beneficiary Bank<span className="text-red-600">*</span>
                    </label>
                  </div>

                  <div className="flex md:gap-2">
                    <div>
                      <span className="text-3xl hidden md:block -ml-8">:</span>
                    </div>

                    <div className="">
                      <select
                        id="beneficiary"
                        value={formData.beneficiary}
                        onChange={handleInputChange}
                        className="md:w-96 w-48 p-2 border border-gray-300 rounded-md shadow-sm focus:ring focus:ring-opacity-50 md:-ml-6"
                        required
                      >
                        <option value="">Select Bank</option>
                        {bankList.map((bank, index) => (
                          <option key={index} value={bank[0.0]}>
                            {bank[0.0]}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>
                </div>
                {/* Tenor Required */}
                <div className="flex flex-col md:flex-row md:items-center md:space-x-0 md:gap-24 gap-1">
                  <div>
                    <label
                      htmlFor="tenor"
                      className="block font-medium text-gray-700 "
                    >
                      <div className="flex md:flex-col md:gap-1">
                        <span>
                          5. Tenor Required
                          <span className="text-red-600">*</span>
                        </span>
                      </div>
                    </label>
                  </div>

                  <div className="flex lg:-space-x-2">
                    <div>
                      <span className="hidden md:block text-3xl -ml-6">:</span>
                    </div>

                    <div className="flex gap-3">
                      <div className="flex md:w-96 w-48 border border-current rounded-sm space-x-1">
                        {['3', '6', '9', '12'].map(tenor => (
                          <button
                            key={tenor}
                            type="button"
                            value={formData.tenor_required}
                            // onChange={handleInputChange}
                            onClick={() => handleTenorRequirdChange(tenor)}
                            // checked={formData.tenor_required === tenor}
                            className={`w-24 ${
                              tenorRequired === tenor
                                ? 'bg-black text-white'
                                : 'bg-gray-200'
                            }`}
                            // id="tenor_required"
                            id={`tenor_required_${tenor}`}
                            required
                          >
                            {tenor}
                          </button>
                        ))}
                      </div>

                      {/* <input
                        type="text"
                        id="tenor_required"
                        value={formData.tenor_required}
                        onChange={handleInputChange}
                        placeholder="Enter Tenor [ 3, 6, 9, 12, 18, 24, 36 ]"
                        className="md:w-96 w-48 p-2 border border-gray-300 rounded-md"
                        required
                      /> */}
                      <p className="text-gray-600 mt-2 font-semibold ">
                        (Months)
                      </p>
                    </div>
                  </div>
                </div>

                {/* Add Document */}
                <div className="flex flex-col md:flex-row md:items-center md:space-x-0 md:gap-24 gap-1">
                  <div>
                    <label
                      htmlFor="addDocument"
                      className="block font-medium text-gray-700"
                    >
                      6. Add Document<span className="text-red-600">*</span>
                    </label>
                  </div>

                  <div className="flex md:gap-2">
                    <div>
                      <span className="hidden md:block text-3xl -ml-6">:</span>
                    </div>

                    <div className="">
                      <input
                        type="file"
                        name="logo"
                        id="document"
                        // onChange={handleFileChange}
                        className="md:w-96 w-48 p-2 bg-white border border-gray-300 rounded-md shadow-sm focus:ring focus:ring-opacity-50 md:-ml-4"
                        // required
                      />
                      <p className='hidden'>
                        {formData.document
                          ? formData.document.name
                          : 'No file selected'}
                      </p>
                    </div>
                  </div>
                </div>
                {/* LC Maturity */}
                <div className="flex flex-col md:flex-row md:items-center md:space-x-0 md:gap-24 gap-1">
                  <div>
                    <label
                      htmlFor="lcMaturity"
                      className="block font-medium text-gray-700"
                    >
                      7. LC Maturity
                    </label>
                  </div>

                  <div className="flex md:gap-2">
                    <div>
                      <span className="hidden md:block text-3xl ml-3">:</span>
                    </div>

                    <div className="">
                      <input
                        type="date"
                        id="lc_maturity"
                        value={formData.lc_maturity}
                        onChange={handleInputChange}
                        className="md:w-96 w-48 p-2 border border-gray-300 rounded-md"
                      />
                    </div>
                  </div>
                </div>
                {/*Product name */}
                <div className="flex flex-col md:flex-row md:items-center md:space-x-0 md:gap-24 gap-1">
                  <div>
                    <label
                      htmlFor="productName1"
                      className="block font-medium text-gray-700"
                    >
                      8. Product Name
                    </label>
                  </div>

                  <div className="flex gap-1">
                    <div>
                      <span className="hidden md:block text-3xl -ml-3">:</span>
                    </div>

                    <div className="">
                      <input
                        type="text"
                        id="product_name"
                        value={formData.product_name}
                        onChange={handleInputChange}
                        placeholder="Enter Product Name"
                        className="md:w-96 w-48 p-2 border border-gray-300 rounded-md"
                        onInput={
                          e =>
                            (e.target.value = e.target.value.replace(
                              /[^a-zA-Z0-9\s]/g,
                              ''
                            )) // allows letters and numbers only
                        }
                      />
                    </div>
                  </div>
                </div>
              </div>
              {/* All form fields end */}

              {/* Apply and cancel Buttons  */}
              <div className="flex md:w-full w-2/3 justify-center space-x-4 mt-6 ">
                <button
                  type="submit"
                  className="bg-headerBtn text-white md:py-2 py-1 md:px-6 px-2 text-xs md:text-sm rounded-lg hover:bg-btnHover"
                >
                  Apply Now
                </button>
                <button
                  onClick={handleCloseApplyLoan}
                  // onClick={handleSubmit}
                  type="button"
                  className="border-headerBtn border-2 text-headerBtn text-xs md:text-sm md:py-2 py-1 md:px-6 px-2 rounded-lg hover:bg-btnHover hover:text-white"
                >
                  Cancel
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </>
  );
};

export default UPAS;

// import React, { useState, useEffect } from 'react';
// import { useNavigate } from 'react-router-dom';
// import axios from 'axios';
// import { format } from 'date-fns';
// import Swal from 'sweetalert2';
// const UPAS = () => {
//   const [currency, setCurrency] = useState('USD($)');
//   const [bankList, setBankList] = useState([]);
//   const [formData, setFormData] = useState({
//     lc_applicant: '',
//     issue_bank: '',
//     amount: '',
//     lc_currency: 'USD($)', //Default
//     lc_value: '',
//     lc_maturity: '',
//     maturity: '',
//     product_name: '',
//     beneficiary: '',
//     // if_Refinance: '',
//     tenor_required: '12',
//   });
//   const [errors, setErrors] = useState({});
//   const [isFormVisible, setIsFormVisible] = useState(true);
//   const [tenorRequired, setTenorRequird] = useState('12');
//   const navigate = useNavigate();

//   const handleCurrencyChange = currency => {
//     setCurrency(currency);
//     setFormData({ ...formData, lc_currency: currency });
//   };
//     const handleTenorRequirdChange = tenor => {
//       setTenorRequird(tenor);
//       setFormData({ ...formData, tenor_required: tenor });
//     };

//   const handleInputChange = e => {
//     const { id, value } = e.target;
//     setFormData({
//       ...formData,
//       [id]: value,
//     });
//   };

//   const handleCloseApplyLoan = () => {
//     setIsFormVisible(false);
//     navigate('/NewLoanApplication');
//   };

//   // get all issue bank api
//   useEffect(() => {
//     const fetchBankList = async () => {
//       try {
//         const response = await axios.get(
//           // 'https://finwise-backend.vercel.app/account/bank-list/',
//           // 'https://finwiseback.finwise.com.bd/account/bank-list/',
//           'http://127.0.0.1:8000/account/bank-list/',
//           {
//             headers: {
//               Cookie:
//                 'csrftoken=YmXTCIwY0VzFyPEcOP15TL1stJiuNrZF; sessionid=l2509fh2uv9ulyzd6412afq0ufd2elpr',
//             },
//             withCredentials: true,
//           }
//         );

//         // Assuming the response has a list of banks
//         setBankList(response.data);
//         // console.log(response);
//       } catch (error) {
//         console.error('Error fetching the bank list:', error);
//       }
//     };

//     fetchBankList();
//   }, []);

//   // fields validation
// const validateForm = () => {
//   let validationErrors = {};

//   // LC Applicant validation (required)
//   if (!formData.lc_applicant)
//     validationErrors.lc_applicant = 'LC Applicant is required';
//   else if (formData.lc_applicant.length < 3)
//     validationErrors.lc_applicant =
//       'LC Applicant must be at least 3 characters long';

//   // Issue Bank validation (required)
//   if (!formData.issue_bank)
//     validationErrors.issue_bank = 'Issue Bank is required';

//   // Amount validation (required, numeric, positive)
//   if (!formData.amount) validationErrors.amount = 'Amount is required';
//   else if (isNaN(formData.amount))
//     validationErrors.amount = 'Amount must be a number';
//   else if (Number(formData.amount) <= 0)
//     validationErrors.amount = 'Amount must be a positive number';

//   // LC Value validation (required, numeric)
//   if (!formData.lc_value) validationErrors.lc_value = 'LC Value is required';
//   else if (isNaN(formData.lc_value))
//     validationErrors.lc_value = 'LC Value must be a number';

//   // LC Maturity validation (required, valid date)
//   if (!formData.lc_maturity)
//     validationErrors.lc_maturity = 'LC Maturity date is required';
//   else {
//     const lcMaturityDate = new Date(formData.lc_maturity);
//     if (isNaN(lcMaturityDate.getTime()))
//       validationErrors.lc_maturity =
//         'LC Maturity must be a valid date (e.g., YYYY-MM-DD)';
//   }

//   // Product Name validation (required, length)
//   if (!formData.product_name)
//     validationErrors.product_name = 'Product Name is required';
//   else if (formData.product_name.length < 2)
//     validationErrors.product_name =
//       'Product Name must be at least 2 characters long';

//   // Beneficiary validation (required)
//   if (!formData.beneficiary)
//     validationErrors.beneficiary = 'Beneficiary is required';

//   // Tenor Required validation (required, numeric, integer)
//   if (!formData.tenor_required)
//     validationErrors.tenor_required = 'Tenor Required is required';
//   else if (
//     isNaN(formData.tenor_required) ||
//     !Number.isInteger(Number(formData.tenor_required))
//   )
//     validationErrors.tenor_required = 'Tenor Required must be an integer';

//   setErrors(validationErrors);
//   return Object.keys(validationErrors).length === 0;
// };

//   const handleSubmit = async e => {
//     e.preventDefault();

//         // if (!validateForm()) {
//         //   return;
//         // }

//     const formattedData = {
//       ...formData,
//       maturity: format(new Date(formData.maturity), 'yyyy-MM-dd'), // Ensure it's in YYYY-MM-DD format
//     };
//     // Log the formData to verify the data being sent
//     console.log('FormData before submit:', formData);

//     try {
//       const response = await axios.post(
//         // 'https://finwise-backend.vercel.app/account/apply-loan/',
//         // 'https://finwiseback.finwise.com.bd/account/apply-loan/',
//         'http://127.0.0.1:8000/account/apply-loan/',
//         formData,
//         // formattedData,
//         {
//           headers: {
//             'Content-Type': 'application/json',
//             // 'X-CSRFToken': 'z91BDRm6OBq66qusVK8HCtvtdW686hFC', // Ensure CSRF token is correct
//           },
//           withCredentials: true, // Include credentials if necessary
//         }
//       );
//         Swal.fire({
//           title: 'Success!',
//           text: 'UPAS application success.',
//           customClass: {
//             popup: 'w-72 h-auto p-3',
//             title: 'text-lg',
//             content: 'text-xs',
//             confirmButton:
//               'bg-headerBtn text-white px-4 py-1 text-sm rounded-md',
//           },
//         });

//       // Log the response from the API call
//       // console.log('Loan application response:', response.data);

//       navigate('/dashboard'); // Navigate to dashboard after successful submission
//     } catch (error) {
//       if (error.response) {
//         // Log detailed server response error
//           Swal.fire({
//             title: 'Error!',
//             text: 'Please provide valid information.',
//             // text: error.response.data.amount
//             //   ? error.response.data[1][0]
//             //   : 'Something went wrong!',
//             // text: error.response.data[1][0],
//             customClass: {
//               popup: 'w-72 h-auto p-3',
//               title: 'text-lg',
//               content: 'text-xs',
//               confirmButton:
//                 'bg-headerBtn text-white px-4 py-1 text-sm rounded-md',
//             },
//           });
//         console.error('Server response error:', error.response.data);
//       } else {
//         // Log any other errors
//         console.error('Error submitting loan application:', error);
//       }
//     }
//   };

//   return (
//     <>
//       {isFormVisible && (
//         <div className="md:px-10 px-2 md:py-10 py-6 ">
//           {/* title header */}
//           <div className="bg-headerBtn md:w-full p-2  md:pl-8 pl-4 text-left rounded-t-lg ">
//             <div className="flex justify-between">
//               <div>
//                 <h2 className="md:text-2xl text-lg text-white font-bold md:mb-2">
//                   Apply for Your UPAS Today
//                 </h2>
//                 <p className="md:mb-2 text-xs md:text-sm text-white">
//                   Quick, Easy, and Secure – Get the Funds You Need Fast
//                 </p>
//               </div>

//               {/* Close button */}
//               {/* <button
//                 onClick={handleCloseApplyLoan}
//                 className="md:mr-4 mr-3 -mt-6 text-white text-2xl font-bold hover:text-btnHover"
//               >
//                 &times;
//               </button> */}
//             </div>
//           </div>

//           {/* form fields */}
//           <div className="bg-AboutUsBg md:text-sm text-xs flex flex-col items-center md:py-10 py-4 px-4 md:px-0 h-screen">
//             <form
//               onSubmit={handleSubmit}
//               action=""
//               className="w-full max-w-4xl"
//             >
//               {/* All form fields start from here */}
//               <div className="md:space-y-2 space-y-2">
//                 {/* LC Applicant */}
//                 <div className="flex flex-col md:flex-row md:items-center md:space-x-0 md:gap-24 gap-1">
//                   <div>
//                     <label
//                       htmlFor="lcApplicant"
//                       className="block font-medium text-gray-700"
//                     >
//                       <div className="flex md:flex-col gap-1">
//                         <span>
//                           1. LC Applicant<span className="text-red-600">*</span>
//                         </span>
//                       </div>
//                     </label>
//                   </div>

//                   <div className="flex md:gap-2">
//                     <div>
//                       <span className="text-3xl hidden md:block ml-0.5">:</span>
//                     </div>

//                     <input
//                       type="text"
//                       id="lc_applicant"
//                       value={formData.lc_applicant}
//                       onChange={handleInputChange}
//                       placeholder="Enter LC Applicant"
//                       className="md:w-96 w-48 p-2 border border-gray-300 rounded-md"
//                       required
//                     />
//                   </div>
//                 </div>
//                 {/* Issue Bank */}
//                 <div className="flex flex-col md:flex-row md:items-center md:space-x-0 md:gap-24 gap-1 ">
//                   <div>
//                     <label
//                       htmlFor="issueBank"
//                       className="block font-medium text-gray-700"
//                     >
//                       2. Issue Bank<span className="text-red-600">*</span>
//                     </label>
//                   </div>

//                   <div className="flex md:gap-2">
//                     <div>
//                       <span className="text-3xl hidden md:block ml-3">:</span>
//                     </div>

//                     <div className="">
//                       <select
//                         id="issue_bank"
//                         value={formData.issue_bank}
//                         onChange={handleInputChange}
//                         className="md:w-96 w-48 p-2 border border-gray-300 rounded-md shadow-sm focus:ring focus:ring-opacity-50"
//                         required
//                       >
//                         <option value="">Select Bank</option>
//                         {bankList.map((bank, index) => (
//                           <option key={index} value={bank[0.0]}>
//                             {bank[0.0]}
//                           </option>
//                         ))}
//                       </select>
//                     </div>
//                   </div>
//                 </div>
//                 {/*LC value */}
//                 <div className="flex flex-col md:flex-row md:items-center md:space-x-0 md:gap-24 gap-1">
//                   <div>
//                     <label
//                       htmlFor="lcValue"
//                       className="block font-medium text-gray-700"
//                     >
//                       3. LC Value<span className="text-red-600">*</span>
//                     </label>
//                   </div>

//                   <div className="flex gap-2">
//                     <div>
//                       <span className="hidden md:block text-3xl ml-6">:</span>
//                     </div>

//                     <div className="flex gap-3  ">
//                       <input
//                         type="text"
//                         id="lc_value"
//                         value={formData.lc_value}
//                         onChange={handleInputChange}
//                         placeholder="Enter LC Value"
//                         className="md:w-96 w-48 p-2 border border-gray-300 rounded-md md:ml-0 -ml-2"
//                         required
//                         onInput={e => {
//                           // Remove non-numeric characters and format with commas every three digits
//                           let value = e.target.value
//                             .replace(/[^0-9]/g, '') // Allows only numbers
//                             .replace(/\B(?=(\d{3})+(?!\d))/g, ','); // Adds a comma every three digits from the right

//                           e.target.value = value;
//                         }}
//                         onBlur={e => {
//                           // Append .00 on blur if not already present
//                           if (!e.target.value.includes('.')) {
//                             e.target.value += '.00';
//                           }
//                         }}
//                       />
//                       {/* currency tab */}
//                       <div className="flex space-x-0 rounded-sm ">
//                         {['USD($)', 'EURO(€)'].map(curr => (
//                           <button
//                             key={curr}
//                             type="button"
//                             onClick={() => handleCurrencyChange(curr)}
//                             className={`lg:py-1 py-0 lg:px-2 px-1.5 border border-black lg:text-sm text-[8px] lg:font-normal font-bold ${
//                               currency === curr
//                                 ? 'bg-black text-white'
//                                 : 'bg-AboutBG'
//                             }`}
//                           >
//                             {curr}
//                           </button>
//                         ))}
//                       </div>
//                     </div>
//                   </div>
//                 </div>
//                 {/* Beneficiary Bank*/}
//                 <div className="flex flex-col md:flex-row md:items-center md:space-x-0 md:gap-24 gap-1 ">
//                   <div>
//                     <label
//                       htmlFor="beneficiary_bank"
//                       className="block font-medium text-gray-700"
//                     >
//                       4. Beneficiary Bank<span className="text-red-600">*</span>
//                     </label>
//                   </div>

//                   <div className="flex md:gap-2">
//                     <div>
//                       <span className="text-3xl hidden md:block -ml-8">:</span>
//                     </div>

//                     <div className="">
//                       <select
//                         id="beneficiary_bank"
//                         value={formData.beneficiary_bank}
//                         onChange={handleInputChange}
//                         className="md:w-96 w-48 p-2 border border-gray-300 rounded-md shadow-sm focus:ring focus:ring-opacity-50 md:-ml-6"
//                         required
//                       >
//                         <option value="">Select Bank</option>
//                         {bankList.map((bank, index) => (
//                           <option key={index} value={bank[0.0]}>
//                             {bank[0.0]}
//                           </option>
//                         ))}
//                       </select>
//                     </div>
//                   </div>
//                 </div>
//                 {/* Tenor Required */}
//                 <div className="flex flex-col md:flex-row md:items-center md:space-x-0 md:gap-24 gap-1">
//                   <div>
//                     <label
//                       htmlFor="tenor"
//                       className="block font-medium text-gray-700 "
//                     >
//                       <div className="flex md:flex-col md:gap-1">
//                         <span>
//                           5. Tenor Required
//                           <span className="text-red-600">*</span>
//                         </span>
//                       </div>
//                     </label>
//                   </div>

//                   <div className="flex lg:-space-x-2">
//                     <div>
//                       <span className="hidden md:block text-3xl -ml-6">:</span>
//                     </div>

//                     <div className="flex gap-3">
//                       <div className="flex md:w-96 w-48 border border-current rounded-sm space-x-1">
//                         {['3', '6', '9', '12'].map(tenor => (
//                           <button
//                             key={tenor}
//                             type="button"
//                             value={formData.tenor_required}
//                             // onChange={handleInputChange}
//                             onClick={() => handleTenorRequirdChange(tenor)}
//                             // checked={formData.tenor_required === tenor}
//                             className={`w-24 ${
//                               tenorRequired === tenor
//                                 ? 'bg-black text-white'
//                                 : 'bg-gray-200'
//                             }`}
//                             // id="tenor_required"
//                             id={`tenor_required_${tenor}`}
//                             required
//                           >
//                             {tenor}
//                           </button>
//                         ))}
//                       </div>

//                       {/* <input
//                         type="text"
//                         id="tenor_required"
//                         value={formData.tenor_required}
//                         onChange={handleInputChange}
//                         placeholder="Enter Tenor [ 3, 6, 9, 12, 18, 24, 36 ]"
//                         className="md:w-96 w-48 p-2 border border-gray-300 rounded-md"
//                         required
//                       /> */}
//                       <p className="text-gray-600 mt-2 font-semibold ">
//                         (Months)
//                       </p>
//                     </div>
//                   </div>
//                 </div>

//                 {/* Add Document */}
//                 <div className="flex flex-col md:flex-row md:items-center md:space-x-0 md:gap-24 gap-1">
//                   <div>
//                     <label
//                       htmlFor="addDocument"
//                       className="block font-medium text-gray-700"
//                     >
//                       6. Add Document<span className="text-red-600">*</span>
//                     </label>
//                   </div>

//                   <div className="flex md:gap-2">
//                     <div>
//                       <span className="hidden md:block text-3xl -ml-6">:</span>
//                     </div>

//                     <div className="">
//                       <input
//                         type="file"
//                         id="addDocument"
//                         name="logo"
//                         // onChange={handleFileChange}
//                         className="md:w-96 w-48 p-2 bg-white  border border-gray-300 rounded-md shadow-sm focus:ring focus:ring-opacity-50 md:-ml-4"
//                       />
//                     </div>
//                   </div>
//                 </div>
//                 {/* LC Maturity */}
//                 <div className="flex flex-col md:flex-row md:items-center md:space-x-0 md:gap-24 gap-1">
//                   <div>
//                     <label
//                       htmlFor="lcMaturity"
//                       className="block font-medium text-gray-700"
//                     >
//                       7. LC Maturity
//                     </label>
//                   </div>

//                   <div className="flex md:gap-2">
//                     <div>
//                       <span className="hidden md:block text-3xl ml-3">:</span>
//                     </div>

//                     <div className="">
//                       <input
//                         type="date"
//                         id="lc_maturity"
//                         value={formData.lc_maturity}
//                         onChange={handleInputChange}
//                         className="md:w-96 w-48 p-2 border border-gray-300 rounded-md"
//                       />
//                     </div>
//                   </div>
//                 </div>
//                 {/*Product name */}
//                 <div className="flex flex-col md:flex-row md:items-center md:space-x-0 md:gap-24 gap-1">
//                   <div>
//                     <label
//                       htmlFor="productName1"
//                       className="block font-medium text-gray-700"
//                     >
//                       8. Product Name
//                     </label>
//                   </div>

//                   <div className="flex gap-1">
//                     <div>
//                       <span className="hidden md:block text-3xl -ml-3">:</span>
//                     </div>

//                     <div className="">
//                       <input
//                         type="text"
//                         id="product_name"
//                         value={formData.product_name}
//                         onChange={handleInputChange}
//                         placeholder="Enter Product Name"
//                         className="md:w-96 w-48 p-2 border border-gray-300 rounded-md"
//                         onInput={
//                           e =>
//                             (e.target.value = e.target.value.replace(
//                               /[^a-zA-Z0-9\s]/g,
//                               ''
//                             )) // allows letters and numbers only
//                         }
//                       />
//                     </div>
//                   </div>
//                 </div>
//               </div>
//               {/* All form fields end */}

//               {/* Apply and cancel Buttons  */}
//               <div className="flex md:w-full w-2/3 justify-center space-x-4 mt-6 ">
//                 <button
//                   // onClick={handleSubmit}
//                   type="submit"
//                   className="bg-headerBtn text-white md:py-2 py-1 md:px-6 px-2 text-xs md:text-sm rounded-lg hover:bg-btnHover"
//                 >
//                   Apply Now
//                 </button>
//                 <button
//                   onClick={handleCloseApplyLoan}
//                   type="button"
//                   className="border-headerBtn border-2 text-headerBtn text-xs md:text-sm md:py-2 py-1 md:px-6 px-2 rounded-lg hover:bg-btnHover hover:text-white"
//                 >
//                   Cancel
//                 </button>
//               </div>
//             </form>
//           </div>
//         </div>
//       )}
//     </>
//   );
// };

// export default UPAS;

// if needed fields
// {
//   /* Amount and Currency Tabs */
// }
// <div className="flex flex-col md:flex-row md:items-center md:space-x-0 md:gap-24  gap-1">
//   <div>
//     <label htmlFor="lcValue" className="block  font-medium text-gray-700">
//       Amount<span className="text-red-600">*</span>
//     </label>
//   </div>

//   <div className="flex md:gap-2">
//     <div>
//       <span className="text-3xl hidden md:block ml-7">:</span>
//     </div>
//     {/* input and currency tab */}
//     <div className="flex lg:gap-3 gap-1">
//       <input
//         type="text"
//         id="amount"
//         value={formData.amount}
//         onChange={handleInputChange}
//         placeholder="30000.00$"
//         className="md:w-96 w-48 p-2 border border-gray-300 rounded-md"
//         required
//         onInput={e => {
//           e.target.value = e.target.value
//             .replace(/[^0-9.]/g, '') // Allows only numbers, comma, and decimal point
//             .replace(/(\..*?)\./g, '$1') // Ensures only one decimal point
//             //.replace(/(,.*?),/g, '$1') // Ensures only one comma
//             .replace(/(\.\d{2})\d+/g, '$1'); // Limits to two digits after the decimal point
//         }}
//       />
//       {/* currency tab */}
//       <div className="flex space-x-0 rounded-sm border border-black md:w-56">
//         {['USD($)', 'EURO(€)', 'GBP(£)'].map(curr => (
//           <button
//             key={curr}
//             type="button"
//             onClick={() => handleCurrencyChange(curr)}
//             className={`lg:py-1 py-0 lg:px-2.5 px-1 border border-black lg:text-sm text-[8px] lg:font-normal font-bold ${
//               currency === curr ? 'bg-black text-white' : 'bg-AboutBG'
//             }`}
//           >
//             {curr}
//           </button>
//         ))}
//       </div>
//     </div>
//   </div>
// </div>;

// {
//   /* Maturity Date */
// }
// <div className="flex flex-col md:flex-row md:items-center md:space-x-0 md:gap-24 gap-1 ">
//   <div>
//     <label htmlFor="maturity" className="block font-medium text-gray-700">
//       Maturity<span className="text-red-600">*</span>
//     </label>
//   </div>

//   <div className="flex md:gap-2">
//     <div>
//       <span className="hidden md:block text-3xl ml-6">:</span>
//     </div>

//     <div className="">
//       <input
//         type="date"
//         id="maturity"
//         value={formData.maturity}
//         onChange={handleInputChange}
//         className="md:w-96 w-48 p-2 border border-gray-300 rounded-md"
//       />
//     </div>
//   </div>
// </div>;

//  {
//    /* Beneficiary */
//  }
//  <div className="flex flex-col md:flex-row md:items-center md:space-x-0 md:gap-24 gap-1 ">
//    <div>
//      <label
//        htmlFor="beneficiary"
//        className="block font-medium text-gray-700"
//      >
//        Beneficiary<span className="text-red-600">*</span>
//      </label>
//    </div>

//    <div className="flex md:gap-2">
//      <div>
//        <span className="hidden md:block text-3xl ml-1.5">:</span>
//      </div>

//      <div className="">
//        <input
//          type="text"
//          id="beneficiary"
//          value={formData.beneficiary}
//          onChange={handleInputChange}
//          placeholder="Enter Beneficiary"
//          className="md:w-96 w-48 p-2 border border-gray-300 rounded-md"
//          required
//          onInput={
//            e =>
//              (e.target.value = e.target.value.replace(/[^a-zA-Z\s]/g, '')) // allows letters and numbers only
//          }
//        />
//      </div>
//    </div>
//  </div>;
